import { parseJson } from 'lib/utils/helpers'

const ACCESS_TOKEN = 'token'
const SEO_DATA = 'seo_data'
const SELECTION_ID = 'selection_id'
const CURRENT_STEP = 'current_step'

export class LocalStorageService {
  static setAccessToken = accessToken => localStorage.setItem(ACCESS_TOKEN, accessToken)

  static getAccessToken = () => localStorage.getItem(ACCESS_TOKEN)

  static removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN)

  static setDataFromSeo = data => localStorage.setItem(SEO_DATA, JSON.stringify(data))
  static getDataFromSeo = () => parseJson(localStorage.getItem(SEO_DATA))
  static removeDataFromSeo = () => localStorage.removeItem(SEO_DATA)

  static setActiveSelectionId = id => localStorage.setItem(SELECTION_ID, id)
  static getSelectionId = () => localStorage.getItem(SELECTION_ID)
  static removeSelectionId = () => localStorage.removeItem(SELECTION_ID)

  static setCurrentStep = step => localStorage.setItem(CURRENT_STEP, step)
  static getCurrentStep = () => localStorage.getItem(CURRENT_STEP)
  static removeCurrentStep = () => localStorage.removeItem(CURRENT_STEP)
}
